import React, { useRef } from 'react';
import { useState, useEffect, usePrintContext, Hooks, Form, Field, Name, Title, Info, Code, Actions, Toast,  API, Utility, Button, Files, Control, Messages, OptionType } from 'helpers/PrintImports';
import { Referral } from "models/ReferralModel";
import { User } from 'models/UserModel';
import { Doctor } from 'models/DoctorModel';
import { RecDoctor } from 'models/RecDoctorModel';
import { Client } from 'models/ClientModel';
import DOMPurify from "dompurify";

const ReferralPrint: React.FC = () => {
  const width = { product: 42, price: 12, qty: 10, discount: 12, gst: 12, Amount: 12 }
  const width2 = { date: 16, receivedfrom: 30, mop: 18, receivedby: 20, amount: 16 }
  const [formId, formName] = [Code.Form.Id.REFERRAL, Code.Form.Name.REFERRAL];
  const {keyId, loading, setLoading, showMenu, setShowMenu, message, setMessage, error, setError, menuPosition, setMenuPosition, contextMenuRef } = usePrintContext();
  const [referralData, setReferralData] = useState<Referral>({});
  const [clientData, setClientData] = useState<Client | null>(null);
  const [doctorData, setDoctorData] = useState<Doctor | null>(null);
  const [recDoctorData, setRecDoctorData] = useState<RecDoctor | null>(null);
  const [userData, setUserData] = useState<User | null>(null);

  Form.Click.Outside([contextMenuRef],[() => setShowMenu(false),() => {}],true);
  const Privilege = Hooks.Privilege.List(formId);
  const printRef = useRef<HTMLDivElement>(null);
  Hooks.Privilege.HasPrint(Privilege);
  const companyId = Utility.Storage.CompanyId();
  const locationId = Utility.Storage.LocationId();

  useEffect(() => {
    API.Data.GetByKeyId<Referral>(formName, keyId, setLoading, setError)
      .then(async(data) => { if(data) {
      const formData = await Form.Map.Data(data);
      setReferralData((prevData) => ({
        ...prevData,
        ...formData,
      }));
      
      setClientData(await API.Data.GetClient(data.client_id));
      // setDoctorData(await API.Data.GetDoctor(data.doctor_id));
      setRecDoctorData(await API.Data.GetRecDoctor(data.recdoctor_id));
      // setUserData(await API.Data.GetUser(data.user_id));

    }})
    setLoading(false);
  }, []); 

  useEffect(() => {
    if (recDoctorData) {
      setClientData((prevData) => ({
        ...prevData,
        client_first_name: recDoctorData.recdoctor_first_name,
        client_middle_name: recDoctorData.recdoctor_middle_name,
        client_last_name: recDoctorData.recdoctor_last_name,
        client_cell: recDoctorData.recdoctor_cell,
        client_phone: recDoctorData.recdoctor_phone,
        client_mobile: recDoctorData.recdoctor_mobile,
        client_email: recDoctorData.recdoctor_email,
        client_fax: recDoctorData.recdoctor_fax,
      }));
    }
  }, [recDoctorData]);  
  
  useEffect(() => {
    console.log('Client Data:', clientData);
  }, [clientData]);  

  return (
    <Control.Print.Frame setMenuPosition={setMenuPosition} setShowMenu={setShowMenu}>
      {!loading && (<>
        <Messages.Toast Messages={message} Error={error} />
        <Button.Print keyId={keyId} formName={formName} Privilege={Privilege} clientData={clientData} fileName='Referral' docType={Code.Option.DocumentType.REFERRALOUT} printRef={printRef} setMessage={setMessage} setError={setError} />
        <Control.Print.Data ref={printRef}>
            {companyId ==10 && (<Control.Box>
              <Field.CompanyHead companyId={companyId} locationId={locationId} />
            </Control.Box>)}
            <Control.Box>
              <div className='print-company'>
                <div className='desc' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(referralData.referral_data!) }} />
              </div>
            </Control.Box>
            <Field.PrintedOn fixed={false} />
        </Control.Print.Data>    
      </>)}
      {showMenu && (<div ref={contextMenuRef}><Control.PrintContextMenu keyId={keyId} showMenu={showMenu} formName={formName}  setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Actions.Print />
    </Control.Print.Frame>
  );
};

export default ReferralPrint;